export default __webpack_public_path__ + "src/images/aachen/landing_background.jpg";